// extracted by mini-css-extract-plugin
var _1 = "PdfViewerSearchPanel-modulePdfViewerSearchPanel__VJqZW";
var _2 = "PdfViewerSearchPanel-modulecheckboxLabel__pdwXi";
var _3 = "PdfViewerSearchPanel-moduleinputField__o42kq";
var _4 = "PdfViewerSearchPanel-moduleloader__I92Go";
var _5 = "PdfViewerSearchPanel-modulenavButton__W9a9h PdfViewerToolbarButton-modulePdfViewerToolbarButton__zwwEi";
var _6 = "PdfViewerSearchPanel-moduleoptions__NcHSk";
var _7 = "PdfViewerSearchPanel-moduleresults__FFaWA";
var _8 = "PdfViewerSearchPanel-modulesummary__hG2wW";
var _9 = "PdfViewerSearchPanel-modulesummaryText__vQkrX";
export { _1 as "PdfViewerSearchPanel", _2 as "checkboxLabel", _3 as "inputField", _4 as "loader", _5 as "navButton", _6 as "options", _7 as "results", _8 as "summary", _9 as "summaryText" }
